export default {
	title: "Importação de Dados",
	subtitle: "Importe consulentes a partir de planilhas XLSX",
	downloadTemplate: "Baixar Modelo",
	uploadFile: "Enviar Arquivo",
	maxSize: "Tamanho máximo: {size}MB",
	preview: "Pré-visualização",
	confirm: "Confirmar Importação",
	validRows: "{count} linha(s) válida(s)",
	invalidRows: "{count} linha(s) com erros",
	totalRows: "{count} linha(s) no total",
	editableHint: "Confira os nomes abaixo. Você pode editar o Nome e Sobrenome diretamente na tabela antes de importar.",
	skippedRowsHint: "{count} linha(s) com erro não serão importadas. Corrija e reenvie a planilha ou importe estes registros posteriormente.",
	success: "{count} pessoa(s) importada(s) com sucesso",
	partialSuccess: "{imported} de {total} pessoa(s) importada(s)",
	goBack: "Voltar",
	errors: {
		fileTooLarge: "Arquivo muito grande. Máximo {size}MB",
		importFailed: "Erro ao importar dados",
	},
	result: {
		title: "Resultado da Importação",
		viewConsultants: "Ver Consulentes",
		importMore: "Importar Mais",
	},
	steps: {
		upload: "Enviar",
		preview: "Revisar",
		result: "Resultado",
	},
	template: {
		instructionsText: "Preencha os dados seguindo o modelo e envie o arquivo para conferência.",
	},
};
